import { Box, Typography } from "@mui/material";
import React from "react";
import { WalletDetial } from "../../../models/settlement.model";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";

interface Props {
  creditAmount: number;
  cashAmount: number;
  totalAmount: number;
  settlementAmount: number;
  walletDetail: WalletDetial[];
  saleType?: string;
  taxAmount: number;
  repaymentFeeAmount: number;
  saleItemsFeeAmount: number;
  supplierSideLoanFeeAmount: number;
  settlementNote: string;
}

const SellDetail = ({
  cashAmount,
  creditAmount,
  settlementAmount,
  totalAmount,
  walletDetail,
  saleType,
  taxAmount,
  repaymentFeeAmount,
  saleItemsFeeAmount,
  supplierSideLoanFeeAmount,
  settlementNote,
}: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        width: "100%",
      }}
    >
      <Box>
        {/* first section */}
        <Box
          sx={{
            border: "1px solid #DAE0E4",
            display: "flex",
            padding: "15px 20px",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Box
            sx={{
              borderBottom:
                walletDetail?.length > 0 ? "2px dashed #DAE0E4" : "",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: "10px",
            }}
          >
            <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
              مبلغ پرداخت اعتباری:
            </Typography>
            <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
              {creditAmount?.toLocaleString("fa")}{" "}
              <span style={{ fontSize: ".9rem" }}>ریال</span>
            </Typography>
          </Box>
          {walletDetail?.map((wallet) => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: "5px",
              }}
            >
              <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
                {wallet?.walletName}
              </Typography>
              <Typography sx={{ fontSize: "1rem", color: "#34495E" }}>
                {Math.abs(wallet?.walletAmount)?.toLocaleString("fa")}{" "}
                <span style={{ fontSize: ".9rem" }}>ریال</span>
                {wallet?.walletAmount > 0 ? (
                  <ArrowUpwardOutlinedIcon sx={{ color: "#01AF43" }} />
                ) : (
                  <ArrowDownwardOutlinedIcon sx={{ color: "#E6123D" }} />
                )}
              </Typography>
            </Box>
          ))}
        </Box>
        {/* second sections */}
        <Box
          sx={{
            border: "1px solid #DAE0E4",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 20px",
            }}
          >
            <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
              مبلغ پرداخت نقدی:
            </Typography>
            <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
              {cashAmount?.toLocaleString("fa")}{" "}
              <span style={{ fontSize: ".9rem" }}>ریال</span>
            </Typography>
          </Box>
          {!!cashAmount && saleType === "Onsite" && (
            <Box sx={{ padding: "10px 20px" }}>
              <Typography
                sx={{
                  color: "#FB8C00",
                  fontSize: ".875rem",
                  fontWeight: "bold",
                }}
              >
                توجه داشته باشید این مبلغ باید توسط فروشنده به صورت نقدی از
                خریدار دریافت شود.
              </Typography>
            </Box>
          )}
        </Box>
        {/* third section */}
        <Box
          sx={{
            border: "1px solid #DAE0E4",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 20px",
            backgroundColor: "#F9FAFC",
          }}
        >
          <Typography
            sx={{
              fontSize: ".9rem",
              color: "#9AAFC4",
            }}
          >
            جمع کل فاکتور:
          </Typography>
          <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
            {totalAmount?.toLocaleString("fa")}{" "}
            <span style={{ fontSize: ".9rem" }}>ریال</span>
          </Typography>
        </Box>
      </Box>

      <Box>
        {saleItemsFeeAmount > 0 && (
          <Box
            sx={{
              border: "1px solid #DAE0E4",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 20px",
              backgroundColor: "#F9FAFC",
            }}
          >
            <Typography
              sx={{
                fontSize: ".9rem",
                color: "#9AAFC4",
              }}
            >
              کارمزد پذیرندگی:
            </Typography>
            <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
              {saleItemsFeeAmount?.toLocaleString("fa")}{" "}
              <span style={{ fontSize: ".9rem" }}>ریال</span>
            </Typography>
          </Box>
        )}
        {supplierSideLoanFeeAmount > 0 && (
          <Box
            sx={{
              border: "1px solid #DAE0E4",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 20px",
              backgroundColor: "#F9FAFC",
            }}
          >
            <Typography
              sx={{
                fontSize: ".9rem",
                color: "#9AAFC4",
              }}
            >
              کارمزد صدور تسهیلات:
            </Typography>
            <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
              {supplierSideLoanFeeAmount?.toLocaleString("fa")}{" "}
              <span style={{ fontSize: ".9rem" }}>ریال</span>
            </Typography>
          </Box>
        )}
        {repaymentFeeAmount > 0 && (
          <Box
            sx={{
              border: "1px solid #DAE0E4",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 20px",
              backgroundColor: "#F9FAFC",
            }}
          >
            <Typography
              sx={{
                fontSize: ".9rem",
                color: "#9AAFC4",
              }}
            >
              کارمزد اقساط:
            </Typography>
            <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
              {repaymentFeeAmount?.toLocaleString("fa")}{" "}
              <span style={{ fontSize: ".9rem" }}>ریال</span>
            </Typography>
          </Box>
        )}
        {taxAmount > 0 && (
          <Box
            sx={{
              border: "1px solid #DAE0E4",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 20px",
              backgroundColor: "#F9FAFC",
            }}
          >
            <Typography
              sx={{
                fontSize: ".9rem",
                color: "#9AAFC4",
              }}
            >
              مالیات بر ارزش افزوده:
            </Typography>
            <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
              {taxAmount?.toLocaleString("fa")}{" "}
              <span style={{ fontSize: ".9rem" }}>ریال</span>
            </Typography>
          </Box>
        )}

        {settlementAmount > 0 && (
          <Box
            sx={{
              border: "1px solid #DAE0E4",
              backgroundColor: "#FFEED9",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 20px",
            }}
          >
            <Typography
              sx={{
                fontSize: "1rem",
                color: "#34495E",
                fontWeight: "bold",
              }}
            >
              مبلغ تسویه حساب با پذیرنده:
            </Typography>
            <Typography sx={{ fontSize: "1.3rem", color: "#34495E" }}>
              {settlementAmount?.toLocaleString("fa")}{" "}
              <span style={{ fontSize: ".9rem" }}>ریال</span>
            </Typography>
          </Box>
        )}
        {settlementNote.length > 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 20px",
            }}
          >
            <Typography
              sx={{ fontSize: ".9rem", color: "#34495E", direction: "rtl" }}
            >
              {settlementNote}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SellDetail;
